//@flow
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import AddSpotlightModal from '../../modals/spotlight/AddSpotlightModal';
import Authenticator from '../../protocol/Authenticator';
import Button from '../../common/Button';
import { isMobile } from '../../util/ScreenUtil';
import SpotlightUtil from '../../queries/spotlight/SpotlightUtil';
import { SPOTLIGHT_CONTENT } from '../../store/Constants';
import Store from '../../store/Store';
import LazyLoader from 'react-lazy-load';
import ImageLoader from '../../common/imageloader/ImageLoader';
import '../../common/imageloader/ImageLoader.css';
import './SpotlightContent.css';
import ThumbnailUtil from '../../util/ThumbnailUtil';
import t from '../../i18n/I18n';
import { ThemeSetup } from '../../themes/ThemeSetup';
import { TextWithEllipsisFileExtension } from '../../common/TextWithEllipsis';
import ToolTip from '../../common/AssetPropertyView';
import TooltipProperties from '../../common/TooltipProperties'

export default class SpotlightContent extends React.Component {
  static propTypes = {
    marginTop: PropTypes.number,
    receiveSpotlightData: PropTypes.func,
    onAssetClick: PropTypes.func,
    isEditMode: PropTypes.bool
  };

  static defaultProps = {
    marginTop: 0,
    receiveSpotlightData: _.noop,
    isEditMode: false
  };

  state = {
    spotlightContent: Store.get(SPOTLIGHT_CONTENT),
    selectedContent: null,
    isEditing: false,
    modal: null,
    totalSpotLightContent: 0
  };

  componentWillMount() {
    this._ismounted = true;
    Store.addListener(SPOTLIGHT_CONTENT, (e) => {
      if (this._ismounted) {
        this.setState({ spotlightContent: e.data, totalSpotLightContent: e.data.length });
      }
    });
    this.issueGetSpotLightQuery();
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.isEditMode != this.props.isEditMode) {
      this.setState({
        isEditing: !this.state.isEditing
      });
    }
  }

  issueGetSpotLightQuery() {
    SpotlightUtil.getSpotlightContentQuery();
  }

  issueRemoveSpotLightQuery(spotlightId: Number, fuid: Number) {
    SpotlightUtil.removeSpotLightQuery(spotlightId, fuid);
  }

  componentWillUnmount() {
    this._ismounted = false;
    Store.removeListener(SPOTLIGHT_CONTENT, () => {});
  }

  reload(): void {
    SpotlightUtil.getSpotlightContentQuery();
  }

  render() {
    const { marginTop } = this.props;
    const { totalSpotLightContent } = this.state;
    if (isMobile()) {
      return (
        <div>
          <div className="field-label">
            <div>
              {t('SPOTLIGHT_SMALL')} ({totalSpotLightContent}){' '}
              <img onClick={this.reload} src="images/refresh.svg" className="reloadImage" />
            </div>
            {Authenticator.AUTH_DATA && Authenticator.AUTH_DATA.userHasAdminPerm ? (
              <Button type="CAPS" onClick={() => this.setState({ isEditing: !this.state.isEditing })}>
                {this.state.isEditing ? t('DONE_LABEL') : t('EDIT')}
              </Button>
            ) : null}
          </div>
          <div className="spotlight-wrapper-outer">
            <div className="spotlight-wrapper-inner" style={{ maxWidth: 'max-content', ...this.props.spotStyle }}>
              <div style={{ marginTop }} name="SpotlightContent">
                {this.state.modal === 'ADD_SPOTLIGHT' ? (
                  <AddSpotlightModal onClose={() => this.setState({ modal: null })} />
                ) : null}
                <div className="contents">
                  {_.map(this.state.spotlightContent, (content) => this.renderItem(content))}
                </div>
                {this.state.isEditing ? (
                  <div>
                    <img
                      src={ThemeSetup.getImageURL('add_proper.svg')}
                      className={classNames('add-spotlight-button', {
                        'mobile-mode': isMobile(),
                        'non-mobile-mode': !isMobile()
                      })}
                      onClick={() => this.setState({ modal: 'ADD_SPOTLIGHT' })}
                    />
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <div style={{ marginTop }} name="SpotlightContent">
            {this.state.modal === 'ADD_SPOTLIGHT' ? (
              <AddSpotlightModal onClose={() => this.setState({ modal: null })} />
            ) : null}
            <header>
              <span>
                {t('SPOTLIGHT')} ({totalSpotLightContent}){' '}
                <img onClick={this.reload} src="images/refresh.svg" style={styles.reloadimage} />
              </span>
              {Authenticator.AUTH_DATA && Authenticator.AUTH_DATA.userHasAdminPerm ? (
                <Button type="CAPS" onClick={() => this.setState({ isEditing: !this.state.isEditing })}>
                  {this.state.isEditing ? t('DONE_LABEL') : t('EDIT')}
                </Button>
              ) : null}
            </header>
            <div className="dskp-contents">
              {_.map(this.state.spotlightContent, (content) => this.renderItem(content))}
            </div>
            {this.state.isEditing ? (
              <ToolTip text={TooltipProperties.AddSpotLight}>
              <img
                src={ThemeSetup.getImageURL('add_proper.svg')}
                className={classNames('add-spotlight-button', {
                  'mobile-mode': isMobile(),
                  'non-mobile-mode': !isMobile()
                })}
                onClick={() => this.setState({ modal: 'ADD_SPOTLIGHT' })}
              />
              </ToolTip>
            ) : null}
          </div>
        </div>
      );
    }
  }

  renderItem(content) {
    const isOverlay = content.description.length !== 0;
    const isSelected = this.state.selectedContent === content.id || isMobile();
    const isFolder = ThumbnailUtil.isFolder(content._fqPath);
    let description = content.description;
    return (
      <div
        onMouseEnter={() => this.setState({ selectedContent: content.id })}
        onMouseLeave={() => this.setState({ selectedContent: null })}
        onClick={() => this.props.onAssetClick(content)}
        key={content.id}
        className="item">
        <div className="content">
          <LazyLoader>
            {isFolder ? (
              <div className={classNames(' folder-wrapper', { active: isSelected })}>
                <ImageLoader src={ThemeSetup.getImageURL('folder.svg')} style={{width: '50px', height: '50px'}}/>
              </div>
            ) : (
              <div className={classNames('body', { active: isSelected })}>
                <ImageLoader src={content.imageUrl} />
              </div>
            )}
          </LazyLoader>
          {isOverlay && !isSelected ? (
            <div className="overlay">
              <div className="text-wrapper">
                <div className="text">{description}</div>
              </div>
            </div>
          ) : isSelected ? (
            <div className="overlay-dark">
              <div className="text-wrapper">
                <div className="text">{description}</div>
              </div>
            </div>
          ) : null}
          <div className={classNames('footer', { active: isSelected })}>
            <div className='footer-content'>
              <TextWithEllipsisFileExtension
                title={content.name}
                text={content.name}
                style={{
                  fontSize: '16px',
                  width: '221px',
                  height: '20px',
                  lineHeight: '19px',
                  margin: '15px 0px 5px'
                }}
              />
              <div className="asset-info">Updated {content.actionTime}</div>
            </div>
          </div>
          {this.state.isEditing ? (
            <img
              className="delete"
              src={ThemeSetup.getImageURL('delete_asset.svg')}
              onClick={(event) => {
                event.stopPropagation();
                this.issueRemoveSpotLightQuery(content.id, content.fuid);
              }}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

const styles = {
  addSpotlightBtn: {
    width: '31px',
    height: '31px',
    cursor: 'pointer',
    marginBottom: '10px',
    marginTop: '-9px'
  },
  reloadimage: {
    cursor: 'pointer',
    width: '14px'
  }
};
